<template>
  <v-list class="ma-0 pa-0">
    <v-list-item class="ma-0 pa-0">
      <v-list-item-content>
        <v-list-item-title>
          {{ brokerName }}
        </v-list-item-title>
        <v-list-item-subtitle>
          <div class="d-flex align-center mb-1">
            <v-icon dense class="mr-2">mdi-calendar-clock</v-icon>
            <span class="caption"> Asignado: {{ assignedDate }} </span>
          </div>
          <div v-if="reviewedDate" class="d-flex align-center mb-1">
            <v-icon dense class="mr-2">mdi-eye-check</v-icon>
            <span class="caption"> Revisado: {{ reviewedDate }} </span>
          </div>
          <div v-if="elapsedTime" class="d-flex align-center mb-1">
            <v-icon dense class="mr-2">mdi-timer</v-icon>
            <span class="caption"> Tiempo de atención: {{ elapsedTime }} </span>
          </div>
          <div v-if="callsCount" class="d-flex align-center">
            <v-icon dense class="mr-2">mdi-phone</v-icon>
            <span class="caption"> {{ callsCount }} llamadas </span>
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action>
        <v-chip v-if="isActive" color="success" small>
          <v-icon left small>mdi-account-check</v-icon>
          Asignación Actual
        </v-chip>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>
<script>
export default {
  name: "CardAssignment",
  props: {
    assignedDate: String,
    reviewedDate: String,
    elapsedTime: String,
    brokerName: String,
    isActive: Boolean,
    callsCount: {
      type: Number,
      default: null
    }
  }
};
</script>
<style lang=""></style>
